import {
  PRIVACY_NOTICE,
  PRIVACY_NOTICE_STATUS,
  PRIVACY_NOTICE_TITLE,
} from '@nemo/core/talent/consent';

/** The notice the apply page's consent links to; no session. */
export function PrivacyPage(): React.JSX.Element {
  return (
    <div className="signin apply">
      <div className="signin-card privacy-notice">
        <h1>{PRIVACY_NOTICE_TITLE}</h1>
        <p className="signin-error">{PRIVACY_NOTICE_STATUS}</p>
        {PRIVACY_NOTICE.map((section) => (
          <section key={section.heading}>
            <h2>{section.heading}</h2>
            {section.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            {section.bullets !== undefined && (
              <ul>
                {section.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </div>
    </div>
  );
}
